export default "__VITE_ASSET___rtnN_Sr__"